import { render, staticRenderFns } from "./Staff02.vue?vue&type=template&id=ebd6f448&"
import script from "./Staff02.vue?vue&type=script&lang=js&"
export * from "./Staff02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports